<template>
    <div>
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        <v-layout row wrap v-else>
            <v-flex xs12>
                {{ $store.getters.language.data.customers.loan_report_title }}
            </v-flex>
            <v-flex xs12>
                <table style="width: 100%;" class="text-center">
                    <thead>
                        <tr>
                            <th class="py-1"> # </th>
                            <th class="py-1"> {{ $store.getters.language.data.customers.customer_name }} </th>
                            <th class="py-1"> {{ $store.getters.language.data.customers.total_loan }} </th>
                            <th class="py-1"> {{ $store.getters.language.data.customers.total_paid_loan }} </th>
                            <th class="py-1"> {{ $store.getters.language.data.customers.total_remain }} </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in rows" :key="item.customer_id">
                            <td> {{ index + 1 }} </td>
                            <td> {{ item.customer_name }} </td>
                            <td> {{ (item.total_invoice_loan).toLocaleString() }} {{ $store.getters.store.store_payment == 'usd' ? '$' : '' }} </td>
                            <td> {{ (item.total_loan).toLocaleString() }} {{ $store.getters.store.store_payment == 'usd' ? '$' : '' }} </td>
                            <td> {{ (item.total_remain_customer_loan).toLocaleString() }} {{ $store.getters.store.store_payment == 'usd' ? '$' : '' }} </td>
                        </tr>
                    </tbody>
                </table>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import requests from '../../../requests/reports.request'
export default {
    props: {
        query: Object
    },   
    data() {
        return {
            rows: [],
            loading: true,
        }
    },
    mounted() {
        this.loading = true;
        var q = 'store_id=' + this.$store.getters.store.store_id;
        const arr = Object.entries(this.query);
        if(arr.length > 0) {
            for(var item of arr) {
                if(item[1] && item[1] != "null" && item != '') {
                    q += '&' + item[0] + '=' + item[1];
                }
            }
        }
        requests.customersLoansReport(q).then(r => {
            this.rows = r.data.rows;
            this.loading = false;
        })
    },
}
</script>

<style scoped>
    table {
        border: 1px solid;
        border-collapse: collapse;
    }
    tr {
        border: 1px solid;
    }
    td, th {
        border: 1px solid;
    }
</style>